import "./navbar.scss"
import ListIcon from '@mui/icons-material/List';
import React, { useState ,useEffect} from 'react';
import { jwtDecode } from "jwt-decode";
import axiosInstance from '../../api/axios';


export const Navbar = () => {
    const [username, setUsername] = useState('');

    const token = localStorage.getItem('token');

    useEffect(() => {

        let decodedToken = null;
        if (token) decodedToken = jwtDecode(token); 
        const displayname = decodedToken.sub;
        localStorage.setItem("username",displayname);
        
        // if(token && decodedToken && decodedToken.sub){
        //     setUsername(decodedToken.sub);
        // }
        if (decodedToken.roles.includes("ROLE_STUDENT")) {
            fetchStudentName(displayname);
          } else {
            setUsername(decodedToken.sub); // For non-students, show the username (enrollment number)
          }
       // console.log("Decoded Token",decodedToken);
    });
    
    const fetchStudentName = async (displayname) => {
        try {
          const response = await axiosInstance.get(`/getStudentByEnrollmentNumber?enrollmentNumber=${displayname}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
    
          if (response.data?.data?.name) {
            setUsername(response.data.data.name); // Set the student's name
          } else {
            setUsername(displayname); // Fallback to username if no name is found
          }
        } catch (error) {
          console.error("Error fetching student name:", error);
          setUsername(displayname); // On error, show the username
        }
      };

      localStorage.setItem("name",username);
      

  return (
    <div className="navbar">
        <div className="wrapper">
            <div className="search">

            </div>
            <div className="items">
                <div className="item" >Welcome {username}
                   {/* <ListIcon className="icon"/>*/}
                </div>
                {/*<div className="item">
                    <img
                        src=""
                        alt=""
                        className="avatar"
                    />
                </div>*/}
            </div>
        </div>
    </div>
  )
}
